import { IsOptional, IsNumber, IsString, IsBoolean, IsArray, Min } from 'class-validator';

export class ClientItemIntegrationDto {
	@IsOptional()
	@IsNumber()
	@Min(1)
	public batchSize?: number;

	@IsOptional()
	@IsNumber()
	@Min(0)
	public tolerance?: number;

	@IsOptional()
	@IsNumber()
	@Min(1)
	public pastDays?: number;

	@IsOptional()
	@IsString()
	public startDate?: string;

	@IsOptional()
	@IsString()
	public endDate?: string;

	@IsOptional()
	@IsBoolean()
	public all?: boolean;

	@IsOptional()
	@IsArray()
	@IsNumber({}, { each: true })
	public itemIds?: Array<number>;
}